<!-- 采集器列表 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="collector-card" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.sbzt')">
              <el-select
                v-model="queryParams.status"
                clearable
                :placeholder="$t('placeholder.qxxsbzt')"
                @keyup.enter.native="handleQuery"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.label"
                  :label="$t(item.label)"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('text.sbxlh')">
              <el-input
                v-model="queryParams.gatewaysn"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="SIM卡号">
              <el-input
                v-model="queryParams.sim"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>

              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="add.show = true"
              >{{ $t('button.tianjia') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <el-table
            v-loading="table.loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            height="calc(100% - 50px)"
            :data="table.data"
          >
            <!-- 序号 -->
            <el-table-column
              width="80"
              type="index"
              :label="$t('text.xh')"
            />
            <!-- 设备状态 -->
            <el-table-column
              :label="$t('text.zt')"
              width="80"
              show-overflow-tooltip
            >
              <template v-slot="scope">
                <span>{{ tableRowDeviceStatus(scope.row) }}</span>
              </template>
            </el-table-column>
            <!-- 设备类型 -->
            <el-table-column
              :label="$t('text.sblx')"
              width="100"
              show-overflow-tooltip
            >
              <template v-slot="scope">
                <span>{{ tableRowDeviceType(scope.row) }}</span>
              </template>
            </el-table-column>
            <!-- SIM卡 -->
            <el-table-column
              label="SIM"
              prop="sim"
              width="200"
              show-overflow-tooltip
            />
            <!-- 到期时间 -->
            <el-table-column
              :label="$t('text.dqsj')"
              prop="expiretime"
              show-overflow-tooltip
            />
            <!-- 采集器序列号 -->
            <el-table-column
              :label="$t('text.sbxlh')"
              prop="gatewaysn"
              show-overflow-tooltip
            />
            <!-- 设备别名 -->
            <el-table-column
              :label="$t('text.sbbm')"
              prop="alias"
              show-overflow-tooltip
            />
            <!-- 电站名称 -->
            <el-table-column
              :label="$t('text.dzmc')"
              prop="orgname"
              show-overflow-tooltip
            />
            <!-- 分销商 -->
            <el-table-column
              :label="$t('text.fxs')"
              prop="distributor"
              show-overflow-tooltip
            />
            <!-- 安装商 -->
            <el-table-column
              :label="$t('text.azs')"
              prop="installer"
              show-overflow-tooltip
            />
            <!-- 终端用户 -->
            <el-table-column
              :label="$t('text.zdyh')"
              prop="terminal"
              show-overflow-tooltip
            />
            <!-- 操作 -->
            <el-table-column
              :label="$t('text.cz')"
              width="80"
            >
              <template v-slot="scope">
                <el-dropdown size="small" @command="handleRowOperate($event, scope.row)">
                  <el-button type="text" style="color: var(--primary-color);" size="small">
                    {{ $t('text.cz') }}<i class="el-icon-arrow-down el-icon--right" />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit" style="color: var(--primary-color)">{{ $t('button.sz') }}</el-dropdown-item>
                    <el-dropdown-item command="delete" divided style="color: var(--danger-color)">{{ $t('button.sc') }}</el-dropdown-item>
                    <el-dropdown-item command="restart" divided style="color: var(--warning-color)">{{ $t('button.cq') }}</el-dropdown-item>
                    <el-dropdown-item command="change" style="color: var(--warning-color)" divided>{{ $t('button.changeGateway') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            :total="page.total"
            background
            layout="prev, pager, next"
            size="small"
            @current-change="getTableData"
          />
        </template>
      </el-card>
    </div>

    <!-- 更新弹出框 -->
    <el-dialog
      :title="$t('text.xgsb')"
      :visible.sync="update.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      append-to-body
    >
      <template #default>
        <el-form :model="update.form">
          <el-form-item :label="$t('text.sbbm')">
            <el-input v-model="update.form.alias" clearable />
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button
          type="primary"
          :loading="update.updateLoading"
          @click="handleUpdateSubmit"
        >{{ $t('button.qd') }}</el-button>
        <el-button @click="update.show = false">{{ $t('button.qx') }}</el-button>
      </template>
    </el-dialog>

    <!-- 添加弹出框 -->
    <el-dialog
      :title="$t('text.tjsb')"
      :visible.sync="add.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      append-to-body
    >
      <template #default>
        <el-form ref="addGatewayFormRef" :model="add.form" :rules="add.formRules">
          <el-form-item :label="$t('text.cjqxlh')" prop="gatewaySn">
            <el-input v-model="add.form.gatewaySn" clearable />
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button
          type="primary"
          :loading="add.addLoading"
          @click="handleAddSubmit"
        >{{ $t('button.qd') }}</el-button>
        <el-button @click="add.show = false">{{ $t('button.qx') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { QueryGateways, UpdateGatewayAlias, DeviceRestart } from '@apis/Device'
import { ChangeGatewayByMeter } from '@apis/Meter'
import { BindGatewayToStation, UnbindGateways } from '@/api/Stations'
export default {
  data () {
    return {
      /** 查询参数 */
      queryParams: {
        orgid: this.$store.getters.station.id,
        gtype: '3'
      },
      /** 设备状态 */
      statusOptions: [
        { label: 'text.zhenc', value: '0' },
        { label: 'text.bfzx', value: '1' },
        { label: 'text.lx', value: '2' },
        { label: 'text.bj', value: '3' }
      ],
      /** 表格配置 */
      table: {
        /** 加载中 */
        loading: false,
        /** 表格数据 */
        data: [],
      },
      /** 分页配置 */
      page: {
        /** 当前页 */
        pageNum: 1,
        /** 每页条数 */
        pageSize: 10,
        /** 总条数 */
        total: 0,
      },
      /** 更新弹框配置 */
      update: {
        /** 显示弹框 */
        show: false,
        /** 表单数据 */
        form: {
          id: '',
          alias: ''
        },
        /** 更新加载中 */
        updateLoading: false,
      },
      /** 添加弹框配置 */
      add: {
        /** 显示弹框 */
        show: false,
        /** 表单数据 */
        form: {
          gatewaySn: ''
        },
        /** 表单验证规则 */
        formRules: {
          gatewaySn: [
            { required: true, message: '请输入采集器编号', trigger: 'blur' }
          ]
        },
        /** 添加加载中 */
        addLoading: false,
      }
    }
  },
  computed: {
    /**
     * 设备状态
     */
    tableRowDeviceStatus (row) {
      return (row) => {
        return row.status === '0' ? this.$i18n.t('text.zx') : row.status === '1' ? this.$i18n.t('text.zx') : this.$i18n.t('text.bj')
      }
    },

    /**
     * 设备类型
     * @param {} row
     */
    tableRowDeviceType (row) {
      return (row) => {
        return row.gtype === '0' ? this.$i18n.t('text.zc') : row.gtype === '1' ? this.$i18n.t('text.cn') : row.gtype === '2' ? this.$i18n.t('text.qx') : this.$i18n.t('text.db')
      }
    },

    /**
     * 续费状态
     * @param {*} row
     */
    tableRowRenewalStatus (row) {
      return (row) => {
        return this.commtypes[row.simstatus].key
      }
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {

    /** 获取表格数据 */
    getTableData () {
      this.table.loading = true
      QueryGateways({
        page: this.page.pageNum,
        perPage: this.page.pageSize,
        orderBy: '',
        whereCondition: JSON.stringify(this.queryParams)
      }).then(({ data }) => {
        this.table.loading = false
        this.table.data = data.queryResults || []
        this.page.total = data.totalCount
      }).catch(() => {
        this.table.loading = false
      })
    },

    /** 查询 */
    handleQuery () {
      this.pageNum = 1
      this.getTableData()
    },

    /**
     * 设备设置
     * @param {*} row
     */
    handleUpdate (row) {
      this.update.form.id = row.id
      this.update.form.alias = row.alias
      this.update.show = true
    },

    /**
     * 删除采集器
     * @param {*} row
     */
    handleDelete (row) {
      this.$confirm(this.$t('notice.sfjb'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          return UnbindGateways({ ids: [row.id] })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.jbcg'))
          this.getTableData()
        })
        .catch(() => {})
    },

    /** 重启采集器
     * @param {*} row
     */
    handleRestart (row) {
      this.$message({
        type: 'warning',
        message: '设备正在重启中！',
        duration: 1 * 1000
      })
      DeviceRestart({
        gatewaysn: row.gatewaysn
      }).then(res => {
        if (res.status && res.status === '0') {
          setTimeout(() => {
            this.$message({
              type: 'success',
              message: '设备重启成功！',
              duration: 1 * 1000
            })
          }, 1500)
        } else if (res.status && res.status === '1') {
          setTimeout(() => {
            this.$message({
              type: 'error',
              message: '设备重启失败！',
              duration: 1 * 1000
            })
          }, 1500)
        }
      })
    },

    /** 添加提交 */
    handleAddSubmit () {
      this.$refs.addGatewayFormRef.validate(validResult => {
        if (validResult) {
          this.add.addLoading = true
          BindGatewayToStation({
            id: this.$store.getters.station.id,
            tag: this.add.form.gatewaySn
          }).then(() => {
            this.$msgSuccess(this.$t('notice.tjsbcg'))
            this.getTableData()
            this.add.addLoading = false
            this.add.show = false
          }).catch(() => {
            this.add.addLoading = false
          })
        }
      })
    },

    /** 更新提交 */
    handleUpdateSubmit () {
      this.update.updateLoading = true
      UpdateGatewayAlias({
        id: this.update.form.id,
        tag: this.update.form.alias
      }).then(() => {
        this.$msgSuccess(this.$t('notice.xgsbcg'))
        this.getTableData()
        this.update.updateLoading = false
        this.update.show = false
      }).catch(() => {
        this.update.updateLoading = false
      })
    },

    /**
     * 更换采集器
     * @param row
     */
    handleChangeGatewayByMeter (row) {
      this.$prompt(this.$t('msg.qsrsn'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        inputPattern: /.+/,
        inputErrorMessage: '请输入采集器编号'
      }).then(({ value }) => {
        ChangeGatewayByMeter({
          oldGatewayId: row.id,
          newGatewaysn: value
        }).then(() => {
          this.$msgSuccess(this.$t('notice.changeGatewayByMeterSuccess'))
          this.getTableData()
        })
      }).then(() => {}).catch(() => {})
    },

    /**
     * 行操作
     * @param {*} command
     * @param {*} row
     */
    handleRowOperate (command, row) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'restart':
          this.handleRestart(row)
          break
        case 'change':
          this.handleChangeGatewayByMeter(row)
          break
      }
    },
  }
}
</script>
<style scoped>
.collector-card{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-border-color);
}
.collector-card >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.collector-card >>> .el-card__header .el-form-item{
  margin-bottom: 0;
}

.collector-card >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 15px;
  box-sizing: border-box;
}
.collector-card >>> .el-card__body .el-pagination{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>

